import fs from 'node:fs'
import path from 'node:path'
import { resolveCliAssetPath } from '@core-engine/utils/cli-root.js'
import type { BetterstartIntegrationId } from '@integration-engine/types.js'

export function integrationTemplateRoot(integrationId: BetterstartIntegrationId): string {
  return resolveCliAssetPath('adapters', 'next', 'integrations', integrationId)
}

export function readIntegrationTemplate(
  integrationId: BetterstartIntegrationId,
  relativePath: string
): string {
  return fs.readFileSync(path.join(integrationTemplateRoot(integrationId), relativePath), 'utf-8')
}
